import { memo, useId } from 'react';

import { XIcon } from '@air/design-icons';

import { useToggleNestedItems } from '~/hooks/search/useToggleNestedItems';

export const GalleryNestedItemsChip = memo(() => {
  const descriptionId = useId();
  const { toggleNestedItems } = useToggleNestedItems();

  return (
    <>
      <button
        aria-describedby={descriptionId}
        className="inline-flex h-6 shrink-0 cursor-pointer items-center gap-1 rounded-6 ads:bg-subtle bg-gray-3 px-2 font-semibold ads:text-secondary text-12 text-gray-11 leading-4 transition-colors ads:hover:bg-hover-subtle hover:bg-gray-4 ads:hover:text-primary hover:text-gray-12"
        data-testid="BOARD_GALLERY_NESTED_ITEMS_CHIP"
        onClick={toggleNestedItems}
        type="button"
      >
        Showing nested items
        <XIcon size="xs" />
      </button>
      <span className="sr-only" id={descriptionId}>
        Fold content into subboards.
      </span>
    </>
  );
});

GalleryNestedItemsChip.displayName = 'GalleryNestedItemsChip';
